import { sanitizeFileAnswer } from "./fileStorage";

export function buildSurveyResponseData(sender) {
  const pages = Array.isArray(sender?.jsonObj?.pages) ? sender.jsonObj.pages : [];
  const allElements = pages.reduce((accumulator, page) => {
    return accumulator.concat(page.elements || []);
  }, []);

  return allElements
    .filter((element) => sender.data.hasOwnProperty(element.name))
    .map((element) => {
      const questionName = element.name;
      const question = sender.getQuestionByName(questionName);
      const questionData = element;

    if (!questionData) {
      return {
        name: questionName,
        title: question?.title || questionName,
        type: "unknown",
        answer: sender.data[questionName],
      };
    }

    let answer = sender.data[questionName];

    if (questionData.type === "file") {
      if (Array.isArray(answer)) {
        answer = answer
          .map((f) => {
            if (!f) return null;
            const content = f.content || "";
            window.__blobUrlMap = window.__blobUrlMap || new Map();
            const s3Path = content.startsWith("blob:")
              ? window.__blobUrlMap.get(content)
              : content.startsWith("s3://") ? content : null;
            if (!s3Path || !s3Path.startsWith("s3://")) return null;
            return {
              name: f.name || f.file?.name || "",
              type: f.type || f.file?.type || "",
              size: Number(f.size || 0),
              path: s3Path,
            };
          })
          .filter(Boolean);
        }
    } else if (questionData.type === "boolean") {
      answer = answer ? "yes" : "no";
    } else if (Array.isArray(answer) && questionData.choices) {
      answer = answer.map((value) => {
        const choice = questionData.choices.find((item) => item.value === value);
        return choice ? choice.text : value;
      });
    } else if (
      (questionData.type === "radiogroup" || questionData.type === "dropdown") &&
      questionData.choices
    ) {
      const choice = questionData.choices.find((item) => item.value === answer);
      answer = choice ? choice.text : answer;
    }

    return {
      name: questionName,
      title: question?.title || questionName,
      type: questionData.type,
      answer,
    };
  });
}